// extracted by mini-css-extract-plugin
export default {"container":"Identity_container__BD6F0","identityIframe":"Identity_identityIframe__a6Tk-"};